/* ==========================================================================
   Sagheer Theme — Predictive search
   يستخدم /search/suggest.json ويحتفظ بآخر عمليات البحث محليًا.
   ========================================================================== */
(function () {
  'use strict';

  const input = document.querySelector('[data-search-input]');
  const resultsEl = document.querySelector('[data-search-results]');
  const defaultEl = document.querySelector('[data-search-default]');
  const recentWrap = document.querySelector('[data-recent-searches]');
  if (!input || !resultsEl) return;

  const strings = (window.theme && window.theme.strings) || {};
  const KEY = 'sagheer:recent-searches';
  let controller;

  /* --------------------------- Recent searches --------------------------- */
  function getRecent() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function saveRecent(term) {
    if (!term || term.length < 2) return;
    let list = getRecent().filter((t) => t !== term);
    list.unshift(term);
    list = list.slice(0, 6);
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function renderRecent() {
    if (!recentWrap) return;
    const list = getRecent();
    if (!list.length) { recentWrap.hidden = true; return; }
    recentWrap.hidden = false;
    const container = recentWrap.querySelector('[data-recent-list]');
    container.innerHTML = list
      .map((t) => '<a class="chip" href="' + window.theme.routes.search + '?q=' + encodeURIComponent(t) + '">' + escapeHtml(t) + '</a>')
      .join('');
  }
  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  renderRecent();

  /* ------------------------------- Render -------------------------------- */
  function renderResults(data, term) {
    const products = (data.resources && data.resources.results && data.resources.results.products) || [];
    const collections = (data.resources && data.resources.results && data.resources.results.collections) || [];

    if (!products.length && !collections.length) {
      resultsEl.innerHTML = '<p class="text-muted center">' + (strings.no_results || 'لا توجد نتائج') + '</p>';
      return;
    }

    let html = '';
    if (products.length) {
      html += '<div class="search-results__group"><p class="search-results__title">' + (strings.products || 'المنتجات') + '</p>';
      html += products
        .map(function (p) {
          const img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
          const price = p.price ? window.Theme.formatMoney(p.price) : '';
          return (
            '<a class="search-result" href="' + p.url + '">' +
            (img ? '<img class="search-result__img" src="' + img + '&width=120" alt="" width="56" height="70" loading="lazy">' : '<span class="search-result__img"></span>') +
            '<span><span class="search-result__title">' + escapeHtml(p.title) + '</span>' +
            (price ? '<span class="search-result__price">' + price + '</span>' : '') +
            '</span></a>'
          );
        })
        .join('');
      html += '</div>';
    }

    if (collections.length) {
      html += '<div class="search-results__group"><p class="search-results__title">' + (strings.collections || 'التصنيفات') + '</p><div class="search-chips">';
      html += collections.map((c) => '<a class="chip" href="' + c.url + '">' + escapeHtml(c.title) + '</a>').join('');
      html += '</div></div>';
    }

    html +=
      '<a class="btn btn--outline btn--full mt-4" href="' + window.theme.routes.search + '?q=' + encodeURIComponent(term) + '">' +
      (strings.view_all || 'عرض كل النتائج') + '</a>';

    resultsEl.innerHTML = html;
  }

  /* -------------------------------- Fetch -------------------------------- */
  const search = window.Theme.debounce(function (term) {
    if (controller) controller.abort();
    controller = new AbortController();
    const url =
      '/search/suggest.json?q=' + encodeURIComponent(term) +
      '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last';

    fetch(url, { signal: controller.signal })
      .then((r) => r.json())
      .then(function (data) { renderResults(data, term); })
      .catch(function () {});
  }, 250);

  input.addEventListener('input', function () {
    const term = input.value.trim();
    if (term.length < 2) {
      resultsEl.innerHTML = '';
      resultsEl.hidden = true;
      if (defaultEl) defaultEl.hidden = false;
      return;
    }
    resultsEl.hidden = false;
    if (defaultEl) defaultEl.hidden = true;
    resultsEl.innerHTML = '<p class="center text-muted"><span class="spinner"></span></p>';
    search(term);
  });

  const form = input.closest('form');
  if (form) {
    form.addEventListener('submit', function () { saveRecent(input.value.trim()); });
  }

  document.addEventListener('drawer:open', function (e) {
    if (e.detail.id === 'SearchDrawer') {
      renderRecent();
      setTimeout(() => input.focus(), 120);
    }
  });
})();
